import { Tfield } from 'src/sections/types';
import { setCTAItems } from './actions/setItems';

export const openUrl = (url: string) => window.open(url, '_blank');
export const socialCount = (field: Tfield) => setCTAItems(field);
